import React from 'react';
import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

const list1 = [
    {
        title: 'Собрали в&nbsp;3&nbsp;раза больше анкет, чем было заявлено в&nbsp;KPI',
        subtitle:
            'На&nbsp;это повлияли креативы, заход через онлайн-формат, квиз, который мы&nbsp;установили на&nbsp;сайт в&nbsp;период работы. Людям стало удобнее подавать заявки. Также мы&nbsp;протестировали 20&nbsp;гипотез для 4&nbsp;целевых аудиторий в&nbsp;течение 2&nbsp;недель и&nbsp;чаще меняли креативы.',
    },
    {
        title: 'Определили самый эффективный формат и площадку для таргетинга',
        subtitle: `<div class="mid-conclusions-spoiler__text">Самый эффективный формат в&nbsp;таргетинге&nbsp;&mdash; сбор заявок. Его преимущество в&nbsp;том, что пользователь остается внутри системы, ему не&nbsp;нужно переходить на&nbsp;внешний сайт. Так не&nbsp;появляется дополнительная точка отказа. А&nbsp;больше всего переходов и&nbsp;лучший результат по&nbsp;цене заявки&nbsp;&mdash; в&nbsp;Instagram. Instagram&nbsp;&mdash; это самая популярная площадка, которая заточена на&nbsp;визуальный контент, поэтому визуальная реклама именно там сработала лучше всего.</div> 
                    <div class="mid-conclusions-spoiler__img-container">
                        <div class="mid-conclusions-spoiler__img"><img src="/images/pic/mid/conc21.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-conclusions-spoiler__small-text">Статистика переходов в&nbsp;Инстаграм</div>
                    <div class="mid-conclusions-spoiler__img-container">
                        <div class="mid-conclusions-spoiler__img"><img src="/images/pic/mid/conc22.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-conclusions-spoiler__small-text">Статистика переходов в&nbsp;Вконтакте</div>`,
    },
    {
        title: 'В контексте большая часть кликов и показа из объявлений РСЯ.',
        subtitle: `<div class="mid-conclusions-spoiler__text">Именно в&nbsp;этих рекламных кампаниях оказались самые популярные ключевые фразы, которые направлены на&nbsp;выпускников 9&nbsp;классов. И&nbsp;так как РСЯ&nbsp;&mdash; это визуальный формат рекламы, а&nbsp;не&nbsp;текстовый, то&nbsp;он&nbsp;сработал лучше.</div> 
                    <div class="mid-conclusions-spoiler__img-container">
                        <div class="mid-conclusions-spoiler__img"><img src="/images/pic/mid/conc31.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-conclusions-spoiler__small-text">Статистика переходов в&nbsp;Вконтакте</div>`,
    },
    {
        title: 'Совместная работа с&nbsp;клиентом дала еще больше результатов',
        subtitle:
            'Помимо большого потока заявок в&nbsp;дне открытых дверей и&nbsp;поступлении важно быстро и&nbsp;качественно их&nbsp;отрабатывать. Клиент самостоятельно принимал и&nbsp;обрабатывал заявки, оперативно давал обратную связь и&nbsp;без посторонней помощи запускал рассылки.',
    },
];

const Conclusions = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="mid-conclusions" bigPaddings={true} isMargin={false}>
                <div className="mid-conclusions__wrapper">
                    <div className="mid-conclusions__container">
                        <div className="mid-conclusions__img-container">
                            <CommonTitle>Выводы</CommonTitle>
                            <CommonSmallText className="mid-conclusions__subtitle">
                                Выполнен большой объем работ и&nbsp;достигнуты поставленные цели
                            </CommonSmallText>
                        </div>
                        <div className="mid-conclusions__info">
                            <div className="mid-conclusions__list">
                                {list1.map(({ title, subtitle }, index) => (
                                    <CommonCollapseItem
                                        key={index}
                                        gray={true}
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        numberColor={'#157fc4'}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                                    </CommonCollapseItem>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Conclusions;
